// eslint-disable-next-line import/no-anonymous-default-export
export default (locations = [], action) => {
  switch (action.type) {
    case "GET_LOCATIONS":
      return action.payload;
    default:
      return locations;
  }
};
